import ClubExamResult from '../../dto/club/ClubExamResult';
import Error from '../../model/Error';
import axios from 'axios';

export default class ClubExamResultRepository {
    static findByClubId(clubId, params, limit, offset) {
        params.limit = limit;
        params.offset = offset;
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/exams/results`, { params })
                .then((response) => resolve(response.data.data.map((data) => ClubExamResult.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static countByClubId(clubId, params) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/exams/results/count`, { params })
                .then((response) => resolve(response.data.data.count))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getExcelByClubIdAndQuery(clubId, params) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/exams/results/export/excel`, { responseType: 'blob', params })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const headerLine = response.headers['content-disposition'];
                    const startFileNameIndex = headerLine.indexOf('"') + 1;
                    const endFileNameIndex = headerLine.lastIndexOf('"');
                    const filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findByClubIdAndExamineeIds(clubId, params) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/exams/results`, { params })
                .then((response) => resolve(response.data.data.map((data) => ClubExamResult.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findById(id) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/club-exam-results/${id}`)
                .then((response) => resolve(ClubExamResult.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubExamResult) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/club-exam-results/${clubExamResult.id}`, clubExamResult.serialize())
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/club-exam-results/${id}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
